module.exports = __webpack_public_path__ + "img/epay-zy-bk.22bb155d.png";